'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAuth = fetchAuth;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var suffix = _enviro2.default.getShort() === 'qa' ? 'qa' : '';

function fetchAuth() {
  return _noAuthApiClient2.default.get('https://api.hubspot' + suffix + '.com/login-verify/echo/user');
}


//////////////////
// WEBPACK FOOTER
// ./js/api/public-only/PublicAuthApi.js
// module id = 879
// module chunks = 4